import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { AuthService } from 'src/app/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class TokenInterceptorService implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    console.log("Interceptando")

    try {
      const usuarioId = JSON.parse(sessionStorage.getItem('usuario'))['idUsuario'];
      const uid = JSON.parse(sessionStorage.getItem('usuario'))['uid'];
      const username = JSON.parse(sessionStorage.getItem('usuario'))['username'];
      const usuarioNombre = JSON.parse(sessionStorage.getItem('usuario'))['nombre'];

      /* If there is a logged-in user, send user information in the headers */
      if(sessionStorage.getItem('uid')){
        request = request.clone({
          setHeaders: {
            usuarioId: usuarioId,
            uid: uid,
            username: username,
            usuarioNombre: usuarioNombre,
          },
        }); 
      }
    } catch (error) {
      // Handle the error, if needed
    }

    return next.handle(request);
  }
}
